import { RouterModule } from '@angular/router';

const routes = [
  {path: '', loadChildren: () => import('app/components/main-view/main-view.module').then(m => m.MainViewModule)}
];

export const Routing = RouterModule.forRoot(routes, { useHash: true });
